import { useRouter } from 'next/router';

var getLocale = function getLocale(router) {
  var _router$locale = router.locale,
      locale = _router$locale === void 0 ? '' : _router$locale,
      defaultLocale = router.defaultLocale,
      _router$locales = router.locales,
      locales = _router$locales === void 0 ? [] : _router$locales;

  if (!locale && !defaultLocale) {
    throw new Error('Define either `defaultLocale` or `locales` in your `next.config.js`');
  }

  return locales.includes(locale) ? locale : defaultLocale;
};

function interpolate(term, params) {
  return Object.keys(params).reduce(function (translation, key) {
    var token = new RegExp("{{ " + key + " }}", 'g');
    return translation.replace(token, String(params[key]));
  }, term);
}
function ssrInterpolate(translationKey) {
  return function (params) {
    var paramsList = Object.keys(params);
    return paramsList.reduce(function (translation, key) {
      var token = new RegExp("{{ " + key + " }}", 'g');
      var translatedTerm = params[key];
      return translation.replace(token, String(translatedTerm));
    }, translationKey);
  };
}

var FIND_VARIABLES_REGEX = /\{\{\s(\S+)\s\}\}/g;
function translator(useFallback, language, locale) {
  return function (term, params) {
    var translatedTerm = language[term];

    if (!useFallback && !translatedTerm) {
      throw new Error("key " + String(term) + " was not found for locale " + locale);
    }

    var translation = Boolean(translatedTerm) ? translatedTerm : term; // pluralization
    // { count: number }

    if (typeof translation === 'string') {
      if (typeof params === 'object') {
        // client-side hook
        return interpolate(translation, params);
      } else if (translation.match(FIND_VARIABLES_REGEX) !== null) {
        // server-side translation
        return ssrInterpolate(translation);
      }
    }

    return translation;
  };
}

function useG11n(dictionary, useFallback) {
  if (useFallback === void 0) {
    useFallback = false;
  }

  var nextRouter = useRouter();
  var locale = getLocale(nextRouter);
  var language = dictionary[locale];
  return {
    translate: translator(useFallback, language, locale)
  };
}

function createFunctionTerm(key, dictionary) {
  var languages = Object.keys(dictionary);
  return languages.reduce(function (keySet, locale) {
    keySet[locale] = dictionary[locale][key];
    return keySet;
  }, {});
}

function clientSideTranslate(term) {
  return Object.keys(term).reduce(function (callTerm, locale) {
    callTerm[locale] = ssrInterpolate(term[locale]);
    return callTerm;
  }, {});
}

function createStaticTerm(key, dictionary) {
  var languages = Object.keys(dictionary);
  return languages.reduce(function (keySet, locale) {
    keySet[locale] = dictionary[locale][key];
    return keySet;
  }, {});
}

export { clientSideTranslate, createFunctionTerm, createStaticTerm, getLocale, useG11n };
//# sourceMappingURL=next-g11n.esm.js.map
